import { Box } from '@mui/material';
import * as Logo from './A_LoadingClientLogo';
import * as LoadingText from './A_LoadingText';

import * as Preact from 'preact';

export interface Props {
    configuratorType: string;
    optionType: string;
    logoUrl?: string;
}

export const Component = (p: Props) => {
    return (
        <Box
            sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                paddingY: '24px',
                boxSizing: 'border-box',
            }}
        >
            {p.logoUrl && <Logo.Component logoUrl={p.logoUrl} />}
            <LoadingText.Component
                configuratorType={p.configuratorType}
                optionType={p.optionType}
            />
        </Box>
    );
};

Component.displayName = 'LoadingInfoContainer';
